import parsePhoneNumber from "libphonenumber-js";
import type { ComponentProps } from "react";

import { TextInput } from "@/components/ui/textInput";

type PhoneInputProps = Omit<ComponentProps<typeof TextInput>, "onChange" | "value"> & {
  onChange: (value: string) => void;
  value: string;
};
export default function PhoneInput({ onChange, value, ...other }: PhoneInputProps) {
  const num = parsePhoneNumber(value);
  const international = num?.formatInternational() || value;
  return (
    <TextInput
      label="Phone number"
      placeholder="Enter your phone number"
      name="phoneNumber"
      type="tel"
      maxLength={20}
      value={international}
      onChange={(event: any) => {
        const text = event.target.value;
        const textWithPlus = text.includes("+") ? text : "+" + text;
        const num = parsePhoneNumber(textWithPlus);
        const international = num?.formatInternational();
        const valueToSet = international || textWithPlus;
        onChange(valueToSet);
      }}
      {...other}
    />
  );
}
